// Janela de Skills igual à do cliente: atributos gerais, magic level e skills com a barra
// de progresso, e os atributos especiais no fim.
import type { CharacterState, SkillId } from '../../../../shared/src/protocol';
import { levelProgress, xpStage } from '../../../../shared/src/game/experience';
import { Widget } from './Widget';
import { vocationTitle } from '../../../../shared/src/game/vocations';

const IMG = '/assets/interface/images';
// Posição de cada ícone em icons-skills.png (9 ícones de 9x9)
const ICON: Record<SkillId | 'magic', number> = { fist: 0, distance: 2, magic: 3, sword: 4, club: 5, axe: 6, shielding: 7, fishing: 8 };
const NAMES: Array<[SkillId, string]> = [
  ['fist', 'Fist Fighting'], ['club', 'Club Fighting'], ['sword', 'Sword Fighting'], ['axe', 'Axe Fighting'],
  ['distance', 'Distance Fighting'], ['shielding', 'Shielding'], ['fishing', 'Fishing'],
];

const fmt = (n: number) => n.toLocaleString('en-US');

function Row(props: { label: string; value: string | number; icon?: number; bar?: number; barColor?: 'red' | 'green' }) {
  return (
    <div class="sk-row">
      <div class="sk-line">
        {props.icon !== undefined && <i class="sk-icon" style={{ backgroundPosition: `-${props.icon * 9}px 0` }} />}
        <span class="sk-label">{props.label}</span>
        <span class="sk-value">{props.value}</span>
      </div>
      {props.bar !== undefined && <div class={'sk-bar ' + (props.barColor ?? 'red')}><i style={{ width: props.bar + '%' }} /></div>}
    </div>
  );
}

export function Skills(props: { c: CharacterState; offlineTraining?: string; progress?: Record<string, number>; special?: { crit: number; critdmg: number; lifeleech: number; manaleech: number } }) {
  const pr = props.progress ?? {};
  const sp = props.special;
  const pct = (v?: number) => (v ?? 0).toFixed(2) + '%';
  const c = props.c;
  return (
    <Widget id="skills" title="Skills" icon={`${IMG}/skin/classic/icon-skills-widget.png`} grow>
      <div class="sk">
        <Row label="Vocation" value={vocationTitle(c.vocation, c.promotion ?? 0)} />
        <Row label="Level" value={c.level} bar={levelProgress(c.level, c.experience)} barColor="green" />
        <Row label="Experience" value={fmt(c.experience)} />
        <Row label="XP Gain Rate" value={xpStage(c.level) * 100 + '%'} />
        <Row label="Hit Points" value={fmt(c.health)} />
        <Row label="Mana" value={fmt(c.mana)} />
        <Row label="Soul Points" value={c.soul} />
        <Row label="Capacity" value={fmt(c.capacity)} />
        <Row label="Speed" value={c.speed} />
        <Row label="Offline Training" value={props.offlineTraining ?? '6:00'} />
        <hr class="sk-sep" />
        <Row label="Magic Level" value={c.magicLevel} icon={ICON.magic} bar={pr.magic ?? 0} />
        {NAMES.map(([id, label]) => <Row key={id} label={label} value={c.skills[id]} icon={ICON[id]} bar={pr[id] ?? 0} />)}
        <hr class="sk-sep" />
        <div class="sk-head">Critical Hit:</div>
        <Row label="  Chance" value={pct(sp?.crit)} />
        <Row label="  Extra Damage" value={pct(sp?.critdmg)} />
        <Row label="Life Leech" value={pct(sp?.lifeleech)} />
        <Row label="Mana Leech" value={pct(sp?.manaleech)} />
      </div>
    </Widget>
  );
}
